import { controls, currencyToNumber, grouped } from "../../controls";

const as = {
  label: "accounts statements",
  starting: true,
  url: "as",
  pageLabel: "accounts statements",
  pageType: "history",

  // filteraction: true,
  filter: [
         ...controls.displayText({ tab: "general", width: "col-sm-1", label: "Account" }),
    ...controls.oc({ tab: "general", width: "col-sm-2", c: "Account", placeHolder: "Account Number", name: "account_code", fastpath: 
    "accounts" }),
    ...controls.showData({ tab: "general", width: "col-sm-2", displaytype: "capital", data: "account_display" }),
     

    ...controls.magicDateLabel({ label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ dateType: "ontype", isRequired: true, name: "from_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),
    
    ...controls.magicDateLabel({ label:"To Date", width:"col-sm-2", target:"to_date" }),
    ...controls.magicDate({ dateType: "ontype", isRequired: true, name:"to_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),
    
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Account Statements",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
     extraRows: {
      location: "top",
      fields: ["credit", "debit"],
      grandtotal: { type: "fixed", displayIn: "customer_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },
      {
        Header: "Date",
        accessor: "value_date",
        type: "date",       
      },
      {
        Header: "particulars",
        accessor: "particulars",
        rwidth: 100
      },
      {
        Header: "Trn type",
        accessor: "transaction_type_display",        

      },
       {
        Header: "opening balance",
        accessor: "opening_balance",        
      },
      {
        Header: "credit",
        accessor: "credit",        
      },
      {
        Header: "debit",
        accessor: "debit",        
      }
    ]
  }
};

export default as;